// The pattern the chat has linkified numbers with since #35. Loose on purpose:
// it takes the separators clients actually type — spaces, dashes, parentheses,
// a leading +420 or 00420 — because the calling box normalizes what it gets.
// The trailing `(?!\d)` keeps it from ending 13 digits into a longer run and
// linking just that much; the other end is checked below, in JS, because
// WKWebView on the iOS 14 deployment target cannot parse a lookbehind.
const PHONE_PATTERN = /(?:[-+00() ]*\d){9,13}(?!\d)/g;

// Splits free text into runs of plain text and runs that are a phone number, so
// a template can render the phone ones as links itself. Segments rather than
// markup: the request description is written by the client, and handing a
// template an HTML string would mean rendering it with v-html.
export default (text = '') => {
  const segments = [];
  let lastIndex = 0;

  for (const match of text.matchAll(PHONE_PATTERN)) {
    // A match whose own first character is a digit and which follows a digit is
    // the tail of something longer — an account or an order number — not a
    // phone. Left in the text run. (A match that starts on a separator does
    // follow a digit whenever two numbers sit next to each other, and is one.)
    if (match.index > 0 && /\d/.test(text[match.index - 1]) && /^\d/.test(match[0])) continue;

    // The pattern also swallows the separators in front of the first digit, so
    // any leading whitespace belongs to the text run, not to the number.
    const phone = match[0].trimStart();
    const start = match.index + match[0].length - phone.length;

    if (start > lastIndex) {
      segments.push({ value: text.slice(lastIndex, start), isPhone: false });
    }

    segments.push({ value: phone, isPhone: true });
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    segments.push({ value: text.slice(lastIndex), isPhone: false });
  }

  return segments;
};
